module.exports = __webpack_public_path__ + "static/media/image-card-1.6c6424db.png";